import { useAuth } from "~/hooks/useAuth";
import { useCollections } from "~/state/collections";
import { usePlantCount } from "~/state/plants";
import {
  allowsCustomMaps,
  collectionAllowance,
  photoAllowance,
  plantAllowance,
  PLAN_LIMITS,
} from "~/utils/plan-limits";
import { planTierFor } from "~/utils/onboarding";

/**
 * Counts come from the local Legend-State store rather than the server so the
 * limit UI stays accurate while offline. The database re-checks on write.
 */
export function usePlan() {
  const { user } = useAuth();
  const tier = planTierFor(user);
  const collections = useCollections();
  const plantCount = usePlantCount();

  return {
    tier,
    isPro: tier === "pro",
    limits: PLAN_LIMITS[tier],
    collections: collectionAllowance(tier, collections.length),
    plants: plantAllowance(tier, plantCount),
    canUseCustomMaps: allowsCustomMaps(tier),
    photosFor: (used: number) => photoAllowance(tier, used),
  };
}
